<template>
	<div ref="slideContainer">
		<div class="operating" v-if="theme == 'red'">
			<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
			<div class="cards">
				<div class="card" v-if="chzzl">
					<div class="head">
						<div class="rectangle">
							<div v-if="language === 'zh'" class="text">{{ jsonData.year }}{{ periodName }}</div>
							<div v-else-if="language === 'en'" class="text">{{ jsonData.year }}{{ periodNameEng }}</div>
						</div>
						<div class="unequal-triangle"></div>

						<div class="icon">
							<img src="../assets/image/red/chzhl.png" />
						</div>
					</div>
					<div v-if="language === 'zh'" class="name">存货周转率</div>
					<div v-else-if="language === 'en'" class="name">Inventory Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText1" class="fade-in-text"
							>{{ chzzl }}<span class="unit">{{ chzzlUnit }}</span></span
						>
					</div>
				</div>
				<div v-if="yszkzzl" class="card" style="border: 1px solid #2d3e50">
					<div class="head">
						<div class="rectangle" style="background-color: #2d3e50; border-color: #2d3e50;">
							<div v-if="language === 'zh'" class="text">{{ jsonData.year }}{{ periodName }}</div>
							<div v-else-if="language === 'en'" class="text">{{ jsonData.year }}{{ periodNameEng }}</div>
						</div>
						<div class="unequal-triangle" style="border-top: 26px solid #2d3e50"></div>

						<div class="icon">
							<img src="../assets/image/red/yszk.png" />
						</div>
					</div>
					<div v-if="language === 'zh'" class="name">应收账款周转率</div>
					<div v-else-if="language === 'en'" class="name" style="margin-top: 22px; height: 40px">Accounts Receivable Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText2" class="fade-in-text"
							>{{ yszkzzl }}<span class="unit">{{ yszkzzlUnit }}</span></span
						>
					</div>
				</div>
				<div class="card" v-if="zzczzl">
					<div class="head">
						<div class="rectangle">
							<div v-if="language === 'zh'" class="text">{{ jsonData.year }}{{ periodName }}</div>
							<div v-else-if="language === 'en'" class="text">{{ jsonData.year }}{{ periodNameEng }}</div>
						</div>
						<div class="unequal-triangle"></div>

						<div class="icon">
							<img src="../assets/image/red/zzc.png" />
						</div>
					</div>
					<div v-if="language === 'zh'" class="name">总资产周转率</div>
					<div v-else-if="language === 'en'" class="name">Total Asset Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText3" class="fade-in-text"
							>{{ zzczzl }}<span class="unit">{{ zzczzlUnit }}</span></span
						>
					</div>
				</div>
			</div>
		</div>

		<div class="operating" v-else-if="theme == 'purple'">
			<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
			<div class="cards">
				<div class="card card1" v-if="chzzl">
					<div class="head">
						<div class="icon">
							<img src="../assets/image/red/chzhl.png" />
						</div>
						<div v-if="language === 'zh'" class="text">{{ jsonData.year }}{{ periodName }}</div>
						<div v-else-if="language === 'en'" class="text">{{ jsonData.year }}{{ periodNameEng }}</div>
					</div>
					<div v-if="language === 'zh'" class="name">存货周转率</div>
					<div v-else-if="language === 'en'" class="name">Inventory Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText1" class="fade-in-text"
							>{{ chzzl }}<span class="unit">{{ chzzlUnit }}</span></span
						>
					</div>
				</div>
				<div v-if="yszkzzl" class="card card2">
					<div class="head">
						<div class="icon">
							<img src="../assets/image/red/yszk.png" />
						</div>
						<div v-if="language === 'zh'" class="text">{{ jsonData.year }}{{ periodName }}</div>
						<div v-else-if="language === 'en'" class="text">{{ jsonData.year }}{{ periodNameEng }}</div>
					</div>
					<div v-if="language === 'zh'" class="name">应收账款周转率</div>
					<div v-else-if="language === 'en'" class="name">Accounts Receivable Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText2" class="fade-in-text"
							>{{ yszkzzl }}<span class="unit">{{ yszkzzlUnit }}</span></span
						>
					</div>
				</div>
				<div class="card card3" v-if="zzczzl">
					<div class="head">
						<div class="icon">
							<img src="../assets/image/red/zzc.png" />
						</div>
						<div v-if="language === 'zh'" class="text">{{ jsonData.year }}{{ periodName }}</div>
						<div v-else-if="language === 'en'" class="text">{{ jsonData.year }}{{ periodNameEng }}</div>
					</div>
					<div v-if="language === 'zh'" class="name">总资产周转率</div>
					<div v-else-if="language === 'en'" class="name">Total Asset Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText3" class="fade-in-text"
							>{{ zzczzl }}<span class="unit">{{ zzczzlUnit }}</span></span
						>
					</div>
				</div>
			</div>
		</div>

		<div class="operating" v-else>
			<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
			<div class="cards">
				<div class="card card1" v-if="chzzl">
					<div class="head">
						<div class="icon">
							<img src="../assets/image/red/chzhl.png" />
						</div>
						<div v-if="language === 'zh'" class="text">{{ jsonData.year }}{{ periodName }}</div>
						<div v-else-if="language === 'en'" class="text">{{ jsonData.year }}{{ periodNameEng }}</div>
					</div>
					<div v-if="language === 'zh'" class="name">存货周转率</div>
					<div v-else-if="language === 'en'" class="name">Inventory Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText1" class="fade-in-text"
							>{{ chzzl }}<span class="unit">{{ chzzlUnit }}</span></span
						>
					</div>
				</div>
				<div v-if="yszkzzl" class="card card2">
					<div class="head">
						<div class="icon yszkzzlIcon">
							<img src="../assets/image/red/yszk.png" />
						</div>
						<div v-if="language === 'zh'" class="text yszkzzlText">{{ jsonData.year }}{{ periodName }}</div>
						<div v-else-if="language === 'en'" class="text yszkzzlTextEng">{{ jsonData.year }}{{ periodNameEng }}</div>
					</div>
					<div v-if="language === 'zh'" class="name yszkzzl-name">应收账款周转率</div>
					<div v-else-if="language === 'en'" class="name">Accounts Receivable Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText2" class="fade-in-text">{{ yszkzzl }}<span class="unit">{{ yszkzzlUnit }}</span></span>
					</div>
				</div>
				<div class="card card3" v-if="zzczzl">
					<div class="head">
						<div class="icon">
							<img src="../assets/image/red/zzc.png" />
						</div>
						<div v-if="language === 'zh'" class="text">{{ jsonData.year }}{{ periodName }}</div>
						<div v-else-if="language === 'en'" class="text">{{ jsonData.year }}{{ periodNameEng }}</div>
					</div>
					<div v-if="language === 'zh'" class="name">总资产周转率</div>
					<div v-else-if="language === 'en'" class="name">Total Asset Turnover</div>
					<div :class="[language === 'zh' ? 'zh_num' : 'en_num']">
						<span ref="fadeInText3" class="fade-in-text"
							>{{ zzczzl }}<span class="unit">{{ zzczzlUnit }}</span></span
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'

export default {
	name: 'operating',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			pageData: {},
			chzzl: '',
			chzzlUnit: '',
			yszkzzl: '',
			yszkzzlUnit: '',
			zzczzl: '',
			zzczzlUnit: '',
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData', 'periodName', 'periodNameEng','isLongChart']),
	},
  watch:{
    language(newVal, oldVal) { // 监听语言变化
      this.initData(); // 初始化数据
    }
  },
	mounted() {
		this.initData(); // 初始化数据
	},
	methods: {
    initData(){
      let data = JSON.parse(this.jsonData.moduleData)
      if (this.language == 'zh') { // 根据语言获取相应数据
        data = JSON.parse(this.jsonData.moduleData)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
      }
      this.pageData = data[this.index] // 获取当前页面数据

      if (this.pageData.chzzlData.length > 0) { // 存货周转率数据
        this.chzzl = (this.pageData.chzzlData[this.pageData.chzzlData.length - 1].value * 1).toFixed(2)
        this.chzzlUnit = this.pageData.chzzlData[this.pageData.chzzlData.length - 1].unit
      }
      if (this.pageData.yszkzzlData.length > 0) { // 应收账款周转率数据
        this.yszkzzl = (this.pageData.yszkzzlData[this.pageData.yszkzzlData.length - 1].value * 1).toFixed(2)
        this.yszkzzlUnit = this.pageData.yszkzzlData[this.pageData.yszkzzlData.length - 1].unit
      }
      if (this.pageData.zzczzlData.length > 0) { // 总资产周转率数据
        this.zzczzl = (this.pageData.zzczzlData[this.pageData.zzczzlData.length - 1].value * 1).toFixed(2)
        this.zzczzlUnit = this.pageData.zzczzlData[this.pageData.zzczzlData.length - 1].unit
      }
      this.initObserver()
    },
    initObserver() {
      const that = this
      if (this.isLongChart) { // 如果是长图，则直接执行渐入动画
        setTimeout(() => {
          that.fadeInText()
        }, 200)
      } else { // 创建一个观察器实例并传入回调函数

        // 创建一个新的 IntersectionObserver 对象，当其监听到目标元素的可见部分（的比例）超过了一个或多个阈值（threshold）时，会执行指定的回调函数
        this.observer = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  that.fadeInText()
                  that.observer.disconnect() // 一旦元素进入视窗，就断开观察器
                }
              })
            },
            {
              threshold: 0.1, // 当目标元素的可见比例达到10%时，触发回调
            }
        )

        this.observer.observe(this.$refs.slideContainer)
      }

    },
		fadeInText() {
			// 使用setTimeout来模拟延迟效果，你可以根据需要调整延迟时间
			const fadeInDuration = 1000 // 渐入持续时间，单位为毫秒
			this.opacity = 0 // 初始透明度设置为0
			// 使用requestAnimationFrame来平滑地改变透明度
			const fade = () => {
				if (this.opacity < 1) {
					this.opacity += 0.05 // 每次增加一点透明度
          if(this.chzzl){
            this.$refs.fadeInText1.style.opacity = this.opacity // 更新元素的不透明度
          }
          if (this.yszkzzl) {
            this.$refs.fadeInText2.style.opacity = this.opacity // 更新元素的不透明度
          }
          if (this.zzczzl) {
            this.$refs.fadeInText3.style.opacity = this.opacity // 更新元素的不透明度
          }
					requestAnimationFrame(fade) // 递归调用requestAnimationFrame来持续更新
				}
			}
			requestAnimationFrame(fade) // 开始渐入动画
		},
	},
}
</script>

<style lang="scss" scoped>
.red {
	.operating {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
	.cards {
		margin-top: 12px;
		padding: 0 30px;
		display: flex;
		justify-content: space-around;
	}

	.card {
		width: 290px;
		height: 319px;
		border-radius: 8px;
		border: 1px solid var(--baseColor);
	}

	.head {
		border: none;
		position: relative;
	}
	.rectangle {
		height: 120px; /* 矩形高度 */
    border: 1px solid #d32f2e;
    border-radius: 8px 8px 0 0; /* 顶部两个角有圆角，底部两个角为0（无圆角） */
		background-color: var(--baseColor); /* 矩形背景色 */
	}

	.unequal-triangle {
		width: 0;
		height: 0;
		border-left: 145px solid transparent; /* 左边框宽度决定三角形的底边 */
		border-right: 145px solid transparent; /* 右边框宽度决定三角形的右边 */
		border-top: 26px solid var(--baseColor); /* 下边框宽度和颜色决定三角形的高和颜色 */
	}
	.text {
		padding-top: 30px;
		text-align: center;
		height: 25px;
		font-size: 18px;
		font-weight: 600;
		color: #ffffff;
		line-height: 25px;
	}
	.icon {
		position: absolute;
		top: 75px;
		left: 117px;
	}

	.name {
		margin-top: 32px;
		text-align: center;
		height: 30px;
		font-size: 22px;
		font-weight: 600;
		color: var(--timeTitleColor);
		line-height: 30px;
	}
	.zh_num {
		margin-top: 7px;
		text-align: center;
		height: 67px;
		font-size: 48px;
		font-weight: 600;
		color: var(--numColor);
		line-height: 67px;
	}
	.en_num {
		margin-top: 22px;
		text-align: center;
		height: 67px;
		font-size: 48px;
		font-weight: 600;
		color: var(--numColor);
		line-height: 67px;
	}
	.unit {
		font-size: 16px;
		color: var(--timeTitleColor);
	}
}

.purple {
	.operating {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
	.cards {
		margin-top: 12px;
		padding: 0 30px;
		display: flex;
		justify-content: space-around;
	}

	.card {
		width: 290px;
		height: 319px;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.card1 {
		background: #fefaef;
		border: 1px solid #ffda88;
	}

	.card2 {
		background: #eef8fd;
		border: 1px solid #abe1fc;
		.icon {
			background: #8bcaea;
		}
	}

	.card3 {
		background: #fdf5f7;
		border: 1px solid #f3adbf;
		.icon {
			background: #f3adbf;
		}
	}
	.head {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.text {
		margin-top: 21px;
		height: 25px;
		font-weight: 600;
		font-size: 18px;
		color: #2a234c;
		line-height: 25px;
	}
	.icon {
		width: 98px;
		height: 98px;
		background: #f9cd70;
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.name {
		margin-top: 5px;
		font-weight: 600;
		font-size: 22px;
		color: #512f80;
		line-height: 30px;
		text-align: center;
    height: 60px;
    align-items: center;
    justify-content: center;
    display: flex;
	}

	.zh_num {
		margin-top: 7px;
		text-align: center;
		height: 67px;
		font-size: 48px;
		font-weight: 600;
		color: var(--numColor);
		line-height: 67px;
	}
	.en_num {
		margin-top: 10px;
		text-align: center;
		height: 67px;
		font-size: 48px;
		font-weight: 600;
		color: var(--numColor);
		line-height: 67px;
	}
	.unit {
		font-size: 16px;
		color: var(--timeTitleColor);
	}
}
.blue {
	.operating {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
		box-shadow: 2px 2px 10px 6px rgba(124, 98, 160, 0.06);
	}
	.cards {
		margin-top: 34px;
		padding: 0;
		display: flex;
		justify-content: center;
	}
	.card {
		width: 290px;
		height: 375px;
		background: #ecf2fd;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.card:nth-child(2) {
		margin-left: 55px;
	}
	.card:nth-child(3) {
		margin-left: 55px;
  }
	.head {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.text {
		margin-top: 21px;
		height: 25px;
		font-weight: 600;
		font-size: 18px;
		color: var(--timeTitleColor);
		line-height: 25px;
	}
	.icon {
		width: 98px;
		height: 98px;
		background: linear-gradient(90deg, #4782ea 0%, #5db6fc 100%);
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.name {
		margin-top: 15px;
		font-weight: 600;
		font-size: 22px;
		color: #3468c4;
		line-height: 30px;
		text-align: center;
    height: 60px;
    align-items: center;
    justify-content: center;
    display: flex;
	}
	.zh_num {
		margin-top: 25px;
		text-align: center;
		height: 67px;
		font-size: 48px;
		font-weight: 600;
		color: var(--numColor);
		line-height: 67px;
	}
	.en_num {
		margin-top: 10px;
		text-align: center;
		height: 67px;
		font-size: 48px;
		font-weight: 600;
		color: var(--numColor);
		line-height: 67px;
	}
	.unit {
		font-size: 16px;
		color: #3468c4;
	}
}

.yellow {
	.operating {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}
	.cards {
		margin-top: 29px;
		padding: 0;
		display: flex;
		justify-content: center;
	}

	.card {
		width: 290px;
		height: 375px;
		background: #ffffff;
		box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.card:nth-child(2) {
		margin-left: 55px;
	}
	.card:nth-child(3) {
		margin-left: 55px;
	}

	.head {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.text {
		margin-top: 21px;
		height: 25px;
		font-weight: 600;
		font-size: 18px;
		color: var(--timeTitleColor);
		line-height: 25px;
	}
	.icon {
		width: 98px;
		height: 98px;
		background: #edae11;
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.name {
		margin-top: 15px;
		font-weight: 600;
		font-size: 22px;
		color: #eda900;
		line-height: 30px;
		text-align: center;
    height: 60px;
    align-items: center;
    justify-content: center;
    display: flex;
	}
	.zh_num {
		margin-top: 10px;
		text-align: center;
		height: 67px;
		font-size: 48px;
		font-weight: 600;
		color: var(--numColor);
		line-height: 67px;
	}
	.en_num {
		margin-top: 24px;
		text-align: center;
		height: 67px;
		font-size: 48px;
		font-weight: 600;
		color: var(--numColor);
		line-height: 67px;
	}
	.unit {
		font-size: 16px;
		color: #eda900;
	}
}

.fade-in-text {
	/* 初始状态透明度为0，实现淡入效果 */
	opacity: 0.01;
	transition: opacity 1s ease-in-out; /* 设置过渡效果，持续时间为1秒 */
}
</style>
